import { Installments } from 'components/Cart/OrderSummary/types';
import { ICheckoutModel } from 'components/Cart/models';

export const getTotalSubscriptionMonthlyHardwarePrice = (
  selectedPurchaseType: Installments,
  checkout: ICheckoutModel,
) => {
  const selectedPlan = checkout.installmentPlans.find(plan => plan.id === selectedPurchaseType);
  const hardwarePrice = selectedPlan?.cost || 0;

  if (!selectedPlan?.cost) return null;

  return Math.ceil(hardwarePrice + checkout.softwareTotal);
};
